import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import 'vue-select/dist/vue-select.css';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import CustomFilterSelector from '@shared/components/filters/custom-filter-selector/custom-filter-selector.vue';
import ExtendedFilter from '@shared/components/filters/extended-filter/extended-filter.vue';
import { v4 as uuidv4 } from 'uuid';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import CashMovementsModal from '@accounting/components/modals/cash-movements-modal/cash-movements-modal.vue';

library.add(faPlus);

@Component({
  name: 'bc-cash-movement-table-input',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-field-wrapper': FieldWrapper,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-drawer-modal': DrawerModal,
    'bpc-custom-filter-selector': CustomFilterSelector,
    'bpc-extended-filter': ExtendedFilter,
    'bc-cash-movements-modal': CashMovementsModal,
  },
})
export default class CashMovementTableInput extends mixins(AbstractField, AbstractTable) {
  declare $refs: AbstractTable['$refs'] & {
    stdCancelForm: InstanceType<typeof StdForm> & {
      formModel: any;
      formProvider: EntityFormProvider;
    };
  };
  @Prop(Array) readonly value: any[];

  @Prop(String) readonly selectEntity: string;
  @Prop(String) readonly selectPluralEntity: string;

  @Prop({ type: String, default: 'drawer' }) readonly type: string;
  @Prop({ type: String, default: 'table-input' }) declare readonly displayConfigName: string;

  @Prop(String) readonly fieldForStorage: string;

  @Prop(Boolean) readonly withDraft: boolean;

  @Prop(String) readonly editFormConfigName: string;
  @Prop(String) readonly permissionEntityName: string;

  @Prop({ type: Boolean, default: false }) readonly withFilters: boolean;
  @Prop({ type: Boolean, default: false }) readonly withCustomFilters: boolean;
  @Prop({ type: Boolean, default: false }) readonly withTabFilters: boolean;
  @Prop({ type: String, default: 'inputTable' }) declare readonly storeName: string;
  @Prop({ type: String, default: 'bpc-std-form' }) declare readonly formComponent: string;

  @Prop({
    type: Array,
    default: () => ['configLoaded', 'paginationLoaded', 'orderLoaded'],
  })
  readonly customFlagsToCheckBeforeLoadEntities: Array<any>;

  public customRowActions = {
    editInModal: {
      activated: false,
      type: 'action',
      icon: 'edit',
      show: false,
      event: 'edit-in-modal',
      text: 'edit',
      permissions: ['update'],
    },
  };
  showCashMovementsModal = false;
  public entity: any = null;
  public selectedEntity: any = null;
  public posSessionId = 0;
  public cashMovementsDefaultAccountId = 0;

  get model(): any[] {
    return this.value;
  }
  set model(val: any[]) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  get showCreateButton(): boolean {
    return true;
  }

  updateRowsActions() {
    this.updatePageActions();
    this.updateRowActions();
    this.getSelection();
  }

  openCreateModal() {
    this.selectedEntity = null;
    this.showCashMovementsModal = true;
  }

  @Watch('value')
  updateItemsProvider() {
    this.$refs.provider.items = this.value;
    if (this.value) {
      if (this.getMode() == 'storage') {
        this.$bpcStorage.set(this.selectPluralEntity, this.value);
      }
      this.updateRowsActions();
    }
    console.log('change items provider');
  }

  beforeMount() {
    this.entityName = this.selectEntity;
    this.pluralEntityName = this.selectPluralEntity;
    this.permissionEntityNameToUse = this.permissionEntityName;
  }

  posSessionIsClosed() {
    return this.formModel?.status == 'closed';
  }

  canAddPosMouvement() {
    return this.$authorizationService.hasPermission('create_cash_movements');
  }

  onCloseShowCashMovementsModal() {
    this.$emit('input-custom-event', { eventName: 'close_cash_movements_modal' });
    this.showCashMovementsModal = false;
    this.getEntities();
  }

  mounted() {
    if (this.$eventsService.events[this.entityName]) {
      this.$eventsService.events[this.entityName].mounted(this);
    }
    if (this.getMode() === 'storage') {
      // WARNING: I think that it doesn't have impact, but if we have problems in the entity table input we should see this line
      this.$bpcStorage.clear(this.pluralEntityName);
    }
    this.posSessionId = this.formModel?.id;
    this.cashMovementsDefaultAccountId = this.formModel?.posBox?.cash_movements_default_account_id;
  }
  destroyed() {
    if (this.$eventsService.events[this.entityName]) {
      this.$eventsService.events[this.entityName].destroy(this);
    }
  }

  getEntities() {
    console.log('model : ' + this.$refs);
    this.$refs.provider.getEntities();
  }

  private modelLoaded;
  onModelLoaded(event) {
    this.modelLoaded = JSON.parse(JSON.stringify(this.$refs.stdForm?.formModel));
  }

  onChange($event) {
    this.$emit('change', $event);
  }

  // TODO: Determine if model has ID or not to consume api or create in localstorage.
  getMode(): string {
    const filter = this.filters.find(filter => filter['filterField'] == this.fieldForStorage);
    if (filter['value']) {
      return 'api';
    } else {
      return 'storage';
    }
  }
  updateModel(): void {
    this.model = this.$refs.provider ? this.$refs.provider.items : null;
  }

  get showedFields() {
    const showedFields = [];
    for (const field of this.$refs.provider.fields) {
      if (!field['conditionalShow']) {
        showedFields.push(field);
      } else {
        const keys = field['conditionalShow']['fieldPath'].split('.');
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let conditionalValue = this;
        for (const key of keys) {
          if (conditionalValue[key] != 'undefined') {
            conditionalValue = conditionalValue[key];
          } else {
            break;
          }
        }
        if (conditionalValue === field['conditionalShow']['value']) {
          showedFields.push(field);
        }
      }
    }
    return showedFields;
  }

  customOnRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'edit-in-modal':
        this.selectedEntity = $event.item.item;
        this.showCashMovementsModal = true;
        break;
    }
  }

  extendUpdateRowActions(entity: any) {
    //check the permissions :
    // - if user has the permission to update, we show the edit button

    if (entity?.actions?.editInModal) {
      entity.actions.editInModal.activated = this.$authorizationService.hasPermission(
        'update_cash_movements',
      );
      entity.actions.editInModal.show = !this.posSessionIsClosed();
    }
    return null;
  }
  triggerPageActions(event) {
    const action = event.action;
    const fieldName = event.fieldName;
    if (this.name == fieldName) {
      this.onPageAction(action);
    }
  }
}
